import React from "react";
import "../Stylesheets/JobGuarantee.css";

const JobGuarantee = () => {
  const features = [
    {
      title: "Complete 6-Month Curriculum",
      description:
        "Evaluation based Internship Program",
    },
    {
      title: "100% Paid Job Guarantee",
      description: "Assured Onboarding to NB Media Tech Pvt Ltd",
    },
    {
      title: "Interview Preparation",
      description:
        "Mock interviews, technical challenges, and presentation skills",
    },
    {
      title: "Attractive Remuneration",
      description: "Salary Up to 15 k Based on Training and Work Performance",
    },
  ];

  const eligibilityRequirements = [
    "Complete all coursework within 8 months",
    "Submit all required projects and assignments",
    "Participate in mock interviews and career prep",
    ,
  ];

  const guaranteeCoverage = [
    "Paid Job Guarantee",
    "Work on real time projects",
    "Mock interviews and personalized feedback sessions",
  ];

  return (
    <div className="min-vh-100 guarantee ">
      <section className="py-5">
        <div className="container">
          {/* Header */}
          <div className="text-center mb-5">
            <h1 className=" display-4 name mb-4" style={{ fontWeight: "700" }}>
              <span className="gradient-text">
                100% Job Guarantee Program
              </span>
            </h1>
            <p className=" mx-auto fs-5" data-testid="guarantee-description" style={{lineHeight:"2"}}>
             Your journey doesn't end with learning. <br/>We guarantee your placement in our company with a structured 6-months internship program.
            </p>
          </div>

          {/* Guarantee Promise */}
          <div className=" my-5" data-testid="guarantee-promise">
            <div
              className="text-center p-4 mx-auto my-5 glass-card"
              style={{ maxWidth: "900px", borderRadius: "20px" }}
            >
              <div className="d-flex align-items-center justify-content-center mb-4">
                <img
                  src="https://cdn.prod.website-files.com/62a8969da1ab561666c8c408/633afe7b71caab29c5b0d068_material-symbols_check-circle.svg"
                  alt="check icon"
                  style={{
                    width: "100%",
                    maxWidth: "50px",
                    boxShadow: "none",
                    filter: "none", 
                    textShadow: "none", 
                  }}
                />
              </div>
              <h2
                className="text-3xl fw-bold mb-4"
                data-testid="guarantee-promise-title"
                style={{ color: "#07dffcff" }}
              >
                100% Job Guarantee
              </h2>
              <p
                className=" fs-5 text-white-50"
                data-testid="guarantee-promise-description"
              >
                Land a IT job with a salary in 6 months of completion of
                TECH BRIDGE program.
              </p>
            </div>
          </div>

          {/* Program Features */}
          <div className="row my-5   ">
            <div className="col-lg-6 pb-5">
              <img
                src="	https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/code2-gif69862_IMG.gif"
                alt="Professional business meeting"
                className="w-100 h-100 object-cover glow-gif "
                data-testid="img-business-meeting"
              />
            </div>
            <div className="col-lg-6">
              <h2
                className="mb-5 d-flex justify-content-center"
                data-testid="features-title "
              >
                What's Included
              </h2>
              <div className="">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-start mb-4"
                    data-testid={`feature-${index}`}
                  >
                    <div
                      className=" rounded-circle d-flex align-items-center justify-content-center me-3 mt-1"
                      style={{ width: "2rem", height: "2rem" }}
                    >
                      <img
                        src="https://cdn.prod.website-files.com/62a8969da1ab561666c8c408/633afe7b71caab29c5b0d068_material-symbols_check-circle.svg"
                        alt="check icon"
                        className="icon-check-circle"
                      />
                    </div>
                    <div>
                      <h3
                        className=" fw-bold mb-2"
                        style={{ color: "#07dffcff" }}
                      >
                        {feature.title}
                      </h3>
                      <p className="text-muted-foreground">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
          </div>

          {/* Terms & Conditions */}
         
          {/* <div className="row mt-5 d-flex justify-content-center">
            <div className="col-lg-10 tech-stack-grid card-custom1 ">
              <div className="p-5" >
                <h3
                  className=" mb-5 text-center text-light fw-bold"
                  style={{ color: "rgb(108, 174, 225)" }}
                >
                  Guarantee Terms
                </h3>
                <div className="row">
                  <div className="col-md-6 mb-4 mb-md-0 ">
                    <h5 className="mb-3">Eligibility Requirements</h5>
                    <ul className="list-unstyled text-secondary">
                      {eligibilityRequirements.map((skill, index) => (
                        <li
                          key={index}
                          className="mb-2"
                          style={{ color: "rgba(198, 200, 201, 1)" }}
                        >
                          <i className="fas fa-code text-success me-2"></i>
                          {skill}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <h5 className="mb-3">Guarantee Coverage</h5>
                    <ul className="list-unstyled text-secondary">
                      {guaranteeCoverage.map((skill, index) => (
                        <li
                          key={index}
                          className="mb-2"
                          style={{ color: "rgba(198, 200, 201, 1)" }}
                        >
                          <i className="fas fa-server text-warning me-2"></i>
                          {skill}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </div>
  );
};

export default JobGuarantee;
